(function () {
  if (!location.pathname.includes('/omega-search')) return;

  const CARD_SELECTOR    = '.os-hit-products';
  const IMAGE_SELECTOR   = 'a.os-image';
  const DETAILS_SELECTOR = '.os-details';
  const REQUIRED_TAG     = '24hour_Y';

  const CTA_HTML = `
    <div class="y24hour-collection_div">
      <p class="y24hour-collection_text">Ready to buy? This product is available at thousands of trusted local retailers.</p>
      <a class="y24hour-collection_link" href="https://www.briggsandstratton.com/na/en_us/support/product-selector.html" target="_blank">Find a Dealer Near You</a>
    </div>
  `;

  function parseTags(val) {
    if (!val) return [];
    if (Array.isArray(val)) return val.map(String);
    return String(val).split(',').map(s => s.trim()).filter(Boolean);
  }

  function getHandleFromHref(href) {
    try {
      const u = new URL(href, location.origin);
      const path = u.pathname.replace(/[?#].*$/, '').replace(/\/+$/, '');
      if (!path.startsWith('/products/')) return null;
      const parts = path.split('/').filter(Boolean); // ['products','<handle>', ...]
      return parts[1] || null;
    } catch {
      return null;
    }
  }

  async function getProductTags(handle) {
    const endpoint = `${location.origin}/products/${handle}.js`;
    const res = await fetch(endpoint, { credentials: 'same-origin' });
    if (!res.ok) return [];
    const data = await res.json();
    return parseTags(data.tags);
  }

  async function run() {
    const cards = document.querySelectorAll(CARD_SELECTOR);

    for (const card of cards) {
      const a = card.querySelector(IMAGE_SELECTOR);
      if (!a) continue;

      const handle = getHandleFromHref(a.getAttribute('href') || '');
      if (!handle) continue;

      const tags = await getProductTags(handle);
      if (!tags.includes(REQUIRED_TAG)) continue;

      const detailsEl = card.querySelector(DETAILS_SELECTOR);
      if (detailsEl) {
        let n = detailsEl.children.length;
        if (n >= 1) detailsEl.removeChild(detailsEl.lastElementChild);
        if (n >= 2) detailsEl.removeChild(detailsEl.lastElementChild);
        detailsEl.insertAdjacentHTML('beforeend', CTA_HTML);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
